import { FormComboComponent, type FormComboComponentProps } from './FormComboComponent'
import { useFormCombo } from './useFormCombo'
import { OptionType } from 'types/OptionType'

type FormComboProps = Omit<FormComboComponentProps, `error` | `onChangeHandler`> & {
  onChange?: (option: OptionType) => void
}

/**
 * Combobox that receives options from props
 * @summary IMPORTANT: the input value will be the entire option object, so the validation schema that parses this input needs to refine the value like this:
 *
 * `comboVal: z.object({ value: z.string(), id: z.string(), name: z.string() }).transform((option) => option.value)`
 */
export default function FormCombo({ name, onChange, ...props }: FormComboProps) {
  const { error, onChangeHandler } = useFormCombo({ name, onChange })
  return <FormComboComponent {...props} name={name} error={error} onChangeHandler={onChangeHandler} />
}
